import { createRequest } from '@savgroup-front-common/core/services/request';

export const GET_OWNER = createRequest('GET_OWNER');
export const GET_PRODUCT = createRequest('GET_PRODUCT');
export const GET_CLAIM = createRequest('GET_CLAIM');
export const GET_WARRANTIES = createRequest('GET_WARRANTIES');
export const GET_TRANSPORT_INFO = createRequest('GET_TRANSPORT_INFO');
